import type { CodeOfConductItem } from '@/components/onboarding/OnboardingCodeOfConduct.vue'
import type { OnboardingTip } from '@/components/onboarding/OnboardingTips.vue'

export const organizationVolunteerPublishChecklist: CodeOfConductItem[] = [
    {
        icon: '💚',
        title: 'Vieme, že dobrovoľníctvo nie je platená práca.',
        description:
            'Dobrovoľník/dobrovoľníčka nenahrádza zamestnanca ani platenú pozíciu. Zohľadňujeme to pri definovaní náplne aj rozsahu spolupráce.'
    },
    {
        icon: '👤',
        title: 'Máme určenú kontaktnú osobu.',
        description:
            'Dobrovoľník/dobrovoľníčka vždy vie, na koho sa môže obrátiť s otázkami alebo pri riešení problémov.'
    },
    {
        icon: '📋',
        title: 'Máme pripravené podmienky spolupráce.',
        description:
            'Vieme dobrovoľníkovi/dobrovoľníčke povedať, s čím konkrétne potrebujeme pomôcť, aký je rozsah spolupráce a čo od nej očakávame.'
    },
    {
        icon: '💬',
        title: 'Budeme komunikovať včas.',
        description:
            'Na prejavený záujem dobrovoľníka/dobrovoľníčky odpovieme najneskôr do 3 pracovných dní.'
    }
]

export const organizationVolunteerPublishTips: OnboardingTip[] = [
    {
        icon: '💡',
        title: 'Zdieľajte svoju príležitosť aj mimo GROWNi.',
        description: 'Pomôže vám to dostať ponuku k ľuďom, ktorí vašu organizáciu už sledujú alebo poznajú.'
    },
    {
        icon: '🔎',
        title: 'Pozrite si profily dobrovoľníkov a dobrovoľníčok.',
        description: 'Oslovte tých, ktorí zodpovedajú vašim potrebám a môžu byť pre príležitosť dobrým matchom.'
    }
]

export const organizationVolunteerInterestTips: OnboardingTip[] = [
    {
        icon: '👋',
        title: 'Spojte sa čo najskôr.',
        description:
            'Pošlite dobrovoľníkovi/dobrovoľníčke kontakt na seba, ak ho ešte nemá, a dohodnite si krátky úvodný rozhovor, ideálne online.'
    },
    {
        icon: '🎯',
        title: 'Pripravte sa na prvé stretnutie.',
        description:
            'Majte jasne zadefinované, čo očakávate, koľko času by vám mal/mala venovať a aká bude jeho/jej úloha. Pripravte si otázky, aby ste zistili, či sú vaše očakávania v súlade.'
    },
    {
        icon: '✅',
        title: 'Vyberajte zodpovedne.',
        description:
            'Je v poriadku, ak sa rozhodnete spoluprácu nezačať. Dôležité je dať dobrovoľníkovi/dobrovoľníčke vedieť včas a s rešpektom.'
    },
    {
        icon: '🔒',
        title: 'Dbajte na bezpečnosť a ochranu údajov.',
        description:
            'Kontaktné údaje a informácie z profilu používajte výlučne na účely dobrovoľníckej spolupráce. Zabezpečte bezpečné podmienky a jasne nastavené hranice vrátane BOZP.'
    }
]

export const organizationVolunteerActiveCooperationTips: OnboardingTip[] = [
    {
        icon: '🤝',
        title: 'Buďte v pravidelnom kontakte.',
        description:
            'Dobrovoľník/dobrovoľníčka by mal/a vedieť, na koho sa môže obrátiť a kde získa podporu.'
    },
    {
        icon: '💬',
        title: 'Poskytujte priebežnú spätnú väzbu.',
        description: 'Pravidelné ocenenie alebo usmernenie pomáha budovať dôveru a dlhodobú spoluprácu.'
    },
    {
        icon: '🙏',
        title: 'Oceňte prínos dobrovoľníka/dobrovoľníčky.',
        description:
            'Nezabudnite poďakovať za jeho/jej čas a energiu. Ak o to požiada, umožnite mu/jej získať potvrdenie o dobrovoľníckej činnosti.'
    },
    {
        icon: '🤝',
        title: 'Ukončujte spoluprácu férovo.',
        description:
            'Ak spoluprácu ukončíte, informujte dobrovoľníka/dobrovoľníčku vopred, poskytnite spätnú väzbu a vytvorte priestor na spätnú väzbu aj z jeho/jej strany.'
    },
    {
        icon: '📣',
        title: 'Udržujte svoje ponuky aktuálne.',
        description:
            'Ak je príležitosť obsadená alebo ukončená, bezodkladne ju deaktivujte, aby sa na ňu nehlásili ďalší dobrovoľníci/dobrovoľníčky.'
    }
]
